<template>
  <div>
    <md-field :class="[getFieldClass]" :md-clearable="clearable">
      <span v-if="title">
        <h5>
          <strong>{{ title }}</strong>
        </h5>
      </span>

      <label v-if="label">{{ label }}</label>
      <md-input
        v-model="content"
        :type="inputType"
        :placeholder="placeholder"
        :required="required"
        :id="inputId"
        :name="name"
        :disabled="disabled"
        :maxlength="maxlength"
        :data-cy="dataCy"
        @focus="$emit('atFocus')"
        @blur="$emit('atBlur')"
        @input="$emit('input', content)"
        @keypress="validateInput"
        @paste="validateInput"
        ref="input"
        v-on:keyup.enter.prevent="$emit('submit')"
        :autofocus="autofocus"
      >
      </md-input>
    </md-field>
    <span class="error" v-if="error">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  name: "SInput",
  props: {
    title: String,
    type: String,
    required: Boolean,
    fieldClass: String,
    label: String,
    clearable: Boolean,
    togglePassword: Boolean,
    placeholder: String,
    inputId: String,
    name: String,
    disabled: Boolean,
    maxlength: Number,
    dataCy: String,
    autofocus: Boolean,
    input: null,
    blockNumbers: Boolean,
    acceptOnlyLetters: Boolean,
    isZipInput: Boolean,
  },
  model: {
    prop: "input",
    event: "input",
  },
  data() {
    return {
      content: this.input || null,
      inputType: this.type,
      errorMessage: null,
      error: false,
    };
  },
  watch: {
    input(newValue) {
      if (this.content !== newValue) this.content = newValue;
    },
  },
  methods: {
    blurEvent() {
      this.$emit("blur");
    },
    validateInput(e) {
      const letterRegex = /^[A-Za-z]+$/;
      const numRegex = /^\d+$/;
      const zipRegex = /^[0-9-]+$/;
      if (e.type === "paste" && this.blockNumbers) {
        e.preventDefault();
      }
      if (e.type === "keypress") {
        if (this.acceptOnlyLetters && !e.key.match(letterRegex)) {
          e.preventDefault();
        }
        if (this.blockNumbers && e.key.match(numRegex)) {
            e.preventDefault();
        }
        if (this.isZipInput && !e.key.match(zipRegex)) {
            e.preventDefault();
        }
      }
    },
    setErrorMessage(message) {
      this.errorMessage = message;
      this.error = true;
    },
    clearError() {
      this.errorMessage = null;
      this.error = false;
    },
    clearContent() {
      this.content = null;
    },
    changeVisibility(e) {
      if (e) {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
    focus() {
      setTimeout(() => {
        this.$refs.input.$el.focus();
      }, 1001);
    },
  },
  computed: {
    getFieldClass() {
      return this.fieldClass;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: default;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
.form-input {
  border: 1px rgba(0, 0, 0, 0.12) solid;
  border-radius: 3px;
}
.md-field:after {
  height: 0;
}
.md-disabled {
  background-color: #e9ecef !important;
}
.md-field:before {
  height: 0px;
}
.md-focused {
  border-color: $primary;
}
.md-field.md-theme-swampum-primary.md-focused label {
  color: $primary;
}
.md-input {
  padding: 5px 0px 5px 11px;
  width: 100%;
  height: 100%;
}
label {
  font-size: 14px;
  margin-left: 11px;
  top: 15px;
}
input {
  top: 15px;
}
</style>

<style lang="scss" scoped>
.md-focused {
  border-color: $primary !important;
}
.md-field.md-theme-swampum-primary.md-focused label {
  color: $primary !important;
}
.error {
  color: $danger;
}
</style>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
